import { createSelector } from 'reselect';

const emptyArray = [];
export const getBalanceSellingAccounts = state => state.data && state.data.balanceSellingAccounts;

export const getBalanceSellingAccountsMap = createSelector(
  [getBalanceSellingAccounts],
  (balanceSellingAccounts) => {
    const map = {};
    (balanceSellingAccounts || []).forEach((account) => {
      map[account.username] = account;
    });
    return map;
  }
);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Data/Data.selector.js